import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Error from 'next/error';
import { logErrorResponse, getBrowserGlobals } from '@sso/core-utils';

import { HTTP_302_MOVED_TEMPORARILY, HTTP_404_NOT_FOUND } from '../../../constants/http-status-codes';
import { getPlidFromRequest } from '../../../helpers/generic-helpers/generic-tools-helper';
import { isBrand } from '../../../helpers/reseller';
import { createRedirectUrl } from '../../../helpers/url/url';
import { CODE_21_ERROR_404 } from '../../../constants/status-codes';

const Page = ({ statusCode, err }) => {
  useEffect(() => {
    const browserGlobals = getBrowserGlobals();
    // https://nextjs.org/docs/advanced-features/error-handling#handling-server-errors
    // By default this page consumes errors in prod mode. We need manually
    // to catch these errors and pass it to the elasticAPM dashboard.
    if (err && browserGlobals?.window.elasticApm) {
      logErrorResponse(err);
    }
    // Don't want to change the app while adding this rule. Please improve when you touch this file
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Error statusCode={statusCode} />;
};

Page.getInitialProps = props => {
  const { req, res, err } = props;
  let statusCode = HTTP_404_NOT_FOUND;

  // This boilerplate was taken from NextJS docs:
  // https://nextjs.org/docs/advanced-features/custom-error-page#more-advanced-error-page-customizing
  if (res) {
    statusCode = res.statusCode;
  } else if (err) {
    statusCode = err.statusCode;
  }

  if (statusCode === HTTP_404_NOT_FOUND) {
    const plid = getPlidFromRequest(req, req.config);

    if (isBrand(plid)) {
      res.redirect(HTTP_302_MOVED_TEMPORARILY, 'https://www.godaddy.com/godaddy-404');
    } else {
      const redirectUrl = createRedirectUrl(req, {
        includeQuery: true,
        status: CODE_21_ERROR_404,
      });

      res.redirect(HTTP_302_MOVED_TEMPORARILY, redirectUrl);
    }
  }

  return { statusCode, err };
};

Page.propTypes = {
  statusCode: PropTypes.number,
  err: PropTypes.object,
};

export default Page;
